import type { FC, ReactNode } from 'react';
import React, { createContext, useContext } from 'react';

type AccessoryCrossSellingContextValue = {
    suppressAccessoryCrossSelling: boolean;
};

const AccessoryCrossSellingContext = createContext<AccessoryCrossSellingContextValue>({
    suppressAccessoryCrossSelling: false
});

type AccessoryCrossSellingProviderProps = {
    suppressAccessoryCrossSelling?: boolean;
    children: ReactNode;
};

export const AccessoryCrossSellingProvider: FC<AccessoryCrossSellingProviderProps> = ({
    suppressAccessoryCrossSelling = true,
    children
}) => (
    <AccessoryCrossSellingContext.Provider value={{ suppressAccessoryCrossSelling }}>
        {children}
    </AccessoryCrossSellingContext.Provider>
);

export const useAccessoryCrossSelling = (): AccessoryCrossSellingContextValue =>
    useContext(AccessoryCrossSellingContext);
